export const filterAlignmentTypes = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

